module.exports = __webpack_public_path__ + "static/media/6-min.5855348b.png";